import { useFilters } from "../../context/filters-context";
import React, { FC } from "react";

// Composant permettant de réinitialiser tous les filtres.
const FiltersContainer: FC = () => {
  const { filters, setFilters } = useFilters();
  const onClickReset = () => {
    setFilters({ date: "", categorie: "", lieu: "" });
  };
  return (
    <button className="spec-filters_reset" onClick={onClickReset}>
      Annuler les filtres
    </button>
  );
};

export default FiltersContainer;
